export const b2cCodes = {
    CANCEL: "AADB2C90091",
    RESET_PASSWORD: "AADB2C90118"
  }; 